import { __decorate } from "tslib";
import Percent from '@/components/Percent.vue';
import DateFilter from '@/components/DateFilter.vue';
import TeamFilter from '@/components/TeamFilter.vue';
import Doughnut from '@/components/Charts/Doughnut.vue';
import LineChart from '@/components/Charts/LineChart.vue';
import PayoutModal from '@/components/PayoutModal.vue';
import Money from '@/components/Money.vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import User from "@/components/User.vue";
import ConfirmableButton from "@/components/ConfirmableButton.vue";
let List = class List extends Vue {
    user;
    dates;
    branchesId;
    extendQuery;
    query = {};
    find;
    patch;
    findExpenseInStore;
    getMember;
    isLoading;
    get expenses() {
        return this.findExpenseInStore({ query: {
                ...this.query,
                _id: { $ne: 'temp' },
            } }).data;
    }
    userWatcher() {
        this.fetchExpenses();
    }
    branchesIdWatcher() {
        this.fetchExpenses();
    }
    datesWatcher() {
        this.fetchExpenses();
    }
    created() {
        this.fetchExpenses();
    }
    fetchExpenses() {
        let query = {
            $sort: {
                expenseOn: -1,
                _id: -1
            },
            ...this.extendQuery
        };
        if (this.dates.start) {
            query.expenseOn = {
                $gte: this.dates.start,
                $lte: this.dates.end
            };
        }
        if (this.branchesId.length > 0)
            query.branchesId = this.branchesId;
        if (this.user.length > 0) {
            query.staffId = { $in: this.user };
        }
        this.query = query;
        this.find({ query });
    }
    cancelExpense(id) {
        this.patch([id, { cancelled: true }, {}]);
    }
};
__decorate([
    Prop(Array)
], List.prototype, "user", void 0);
__decorate([
    Prop(Object)
], List.prototype, "dates", void 0);
__decorate([
    Prop(Array)
], List.prototype, "branchesId", void 0);
__decorate([
    Prop({ type: Object, default: () => ({}) })
], List.prototype, "extendQuery", void 0);
__decorate([
    Watch('user')
], List.prototype, "userWatcher", null);
__decorate([
    Watch('branchesId')
], List.prototype, "branchesIdWatcher", null);
__decorate([
    Watch('dates')
], List.prototype, "datesWatcher", null);
List = __decorate([
    Component({
        components: {
            ConfirmableButton,
            User,
            Percent,
            Doughnut,
            LineChart,
            DateFilter,
            TeamFilter,
            PayoutModal,
            Money
        },
        computed: {
            ...mapState('expense', { isLoading: 'isFindPending' }),
            ...mapGetters('users', { getMember: 'get' }),
            ...mapGetters('expense', { findExpenseInStore: 'find' }),
        },
        methods: {
            ...mapActions('expense', ['find', "patch"]),
        }
    })
], List);
export default List;
